const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
};

// TODO: Update font-size based on layout
document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	leftOptions: [
		{ id: 1, label: "Substances actives" },
		{ id: 2, label: "Piasclédine®300" },
		{ id: 3, label: "Dose recommandée" },
		{ id: 4, label: "Populations concernées" },
		{ id: 5, label: "Oubli de prise" },
		{ id: 6, label: "Effet retardé" },
		{ id: 7, label: "Prise quotidienne" },
		{ id: 8, label: "Indication" },
		{ id: 9, label: "Procédé de fabrication" },
	],
	rightOptions: [
		{ id: 10, label: "Breveté" },
		{ id: 11, label: "Adultes sauf femmes enceintes ou allaitantes<br/>ou en âge de procréer sans contraception" },
		{ id: 12, label: "Action lente, retardée d'environ 2 mois pouvant persister après arrêt du traitement" },
		{ id: 13, label: "Insaponifiables d’huiles d’avocat et de soja" },
		{ id: 14, label: "1 gélule par jour soit 300 mg" },
		{ id: 15, label: "Lors du repas, avec un grand verre d’eau" },
		{ id: 16, size: '0.75em', label: "Chez l’adulte en traitement symptomatique (douleur et gêne<br/>lors des mouvements) à effet différé de l'arthrose du genou" },
		{ id: 17, label: "Ne pas prendre de double dose" },
		{ id: 18, size: '0.7em', lineHeight: '1.1em', label: "Il agit sur les articulations (il appartient au groupe<br/>de médicaments appelés autres agents anti-inflammatoires<br/>et antirhumatismaux, non stéroïdiens)" },
	],
	answers: {
		1: 13,
		2: 18,
		3: 14,
		4: 11,
		5: 17,
		6: 12,
		7: 15,
		8: 16,
		9: 10
	},
	selected: { left: -1, right: -1 },
	foundCount: 0,
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this.renderPlayingState();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	renderPlayingState() {
		document.getElementById("success-area").innerHTML = "";
		document.getElementById("error-area").innerHTML = "";
		this.foundCount = 0;

		const leftCol = document.getElementById("choices-left-col");
		let leftColHtml = "";
		this.leftOptions.forEach(option => {
			leftColHtml += `<div class="option" id="option-${option.id}"
data-id="${option.id}"
onclick="document.Game.select('left', ${option.id})"
>${option.label}</div>`;
		});
		leftCol.innerHTML = leftColHtml;

		const rightCol = document.getElementById("choices-right-col");
		let rightColHtml = "";
		this.rightOptions.forEach(option => {
			rightColHtml += `<div class="option" id="option-${option.id}"
data-id="${option.id}"
onclick="document.Game.select('right', ${option.id})"
><span style="font-size: ${option.size || '1em'}; line-height: ${option.lineHeight || '1em'}">${option.label}</span></div>`;
		});
		rightCol.innerHTML = rightColHtml;
	},
	select(key, id) {
		this.selected[key] = id;

		// Set selected style
		const colContainer = document.getElementById("choices-" + key + "-col");
		let optionsSelected = colContainer.getElementsByClassName("option selected");
		for (let i = 0; i < optionsSelected.length; i++) {
			optionsSelected[i].classList.remove("selected");
		}
		const area = document.getElementById("choices-area");
		const option = document.getElementById("option-" + id);
		if (!area.classList.contains("content-selected")) {
			area.classList.add("content-selected");
		}
		if (!option.classList.contains("selected")) {
			option.classList.add("selected");
		}

		// If both values are set, check match
		const { left, right } = this.selected;
		if (left === -1 || right === -1) {
			return;
		}
		// In case we answer quickly
		document.getElementById("success-message")?.remove();

		const leftOption = this.leftOptions.find(o => o.id === left);
		const rightOption = this.rightOptions.find(o => o.id === right);

		if (this.answers[left] === right) { // Success
			// Remove selected options
			document.getElementById("option-" + left).remove();
			document.getElementById("option-" + right).remove();

			// Add success line
			const successArea = document.getElementById("success-area");
			successArea.innerHTML += `<div class="success-line">
<div class="left-col">${leftOption.label}</div>
<div class="right-col"><span style="font-size: ${rightOption.size || '1em'}; line-height: ${rightOption.lineHeight || '1em'}">${rightOption.label}</span></div>
<div id="success-message">Exact</div>
</div>`;
			setTimeout(() => {
				document.getElementById("success-message")?.remove();

				this.foundCount += 1;
				if (this.foundCount === this.leftOptions.length) {
					this.state = GameState.done;
					this.render();
				}
			}, 2000);
		} else {
			const leftColOption = document.getElementById("option-" + left);
			const rightColOption = document.getElementById("option-" + right);

			// Hide both
			leftColOption.classList.add("hidden");
			rightColOption.classList.add("hidden");

			// Set error-area content
			const errorArea = document.getElementById("error-area");
			errorArea.innerHTML = `
<div>${leftOption.label}</div>
<div><span style="font-size: ${rightOption.size || '1em'}; line-height: ${rightOption.lineHeight || '1em'}">${rightOption.label}</span></div>`;

			// Show tooltip
			const errorDiv = document.createElement('div');
			errorDiv.innerHTML = "<strong>Oups !</strong> Ce n'est pas<br/>la bonne paire.";
			errorDiv.setAttribute("id", "error-message");
			errorArea.appendChild(errorDiv);

			// Rollback after 2s
			setTimeout(() => {
				errorArea.innerHTML = "";
				leftColOption.classList.remove("hidden");
				rightColOption.classList.remove("hidden");
			}, 2000);
		}

		area.classList.remove("content-selected");
		document.getElementById("option-" + left)?.classList.remove("selected");
		document.getElementById("option-" + right)?.classList.remove("selected");
		this.selected = { left: -1, right: -1 };
	},
	answer() {

	},
	restart() {
		this.state = GameState.playing;
		this.render();
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();
addEventListener('resize', document.computeSizes);
